import React, { useState, useEffect } from 'react';
import checkLogin from "../function/checkLogin.js";
import getUrl from "../function/getUrl.js";

const token = sessionStorage.getItem("token");

// 課程方案（銷售方案）管理平台
const GetSalesEventList = (props) => {
  checkLogin();
  
  const url = getUrl();
  const operator = sessionStorage.getItem("staffDBID");

  const [classList, setClassList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentEvent, setCurrentEvent] = useState({
    eventDBID: "",
    eventID: "",
    eventName: "",
    classAmount: "",
    eventPrice: "0",
    classDays: "0",
    forMember: "true",
    alive: "true",
    detail: "",
    forTrial: "false",
    forELP: "0"
  });

  // 取得所有銷售方案清單
  const getData = () => {
    fetch(`${url}/appGet/getSalesEventList?token=${token}`)
      .then((res) => res.json())
      .then((json) => {
        if (Array.isArray(json)) {
          setClassList(json);
        } else {
          console.error("API Response is not an array:", json);
        }
      })
      .catch((err) => {
        console.error("Error fetching sales events:", err);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  // 搜尋過濾
  const filteredList = classList.filter((item) => {
    const nameMatch = item.eventName && item.eventName.toLowerCase().includes(searchTerm.toLowerCase());
    const idMatch = item.eventID && item.eventID.toLowerCase().includes(searchTerm.toLowerCase());
    return nameMatch || idMatch;
  });

  // 開啟新增 Modal
  const handleAddNew = () => {
    setCurrentEvent({
      eventDBID: "",
      eventID: "取得中...",
      eventName: "",
      classAmount: "",
      eventPrice: "0",
      classDays: "0",
      forMember: "true",
      alive: "true",
      detail: "",
      forTrial: "false",
      forELP: "0"
    });
    setIsEditMode(false);
    setShowModal(true);

    // 從後端非同步取得自動產生的最新編號
    fetch(`${url}/appGet/getNextEventID?token=${token}`)
      .then((res) => res.json())
      .then((json) => {
        if (json.eventID) {
          setCurrentEvent(prev => ({
            ...prev,
            eventID: json.eventID
          }));
        }
      })
      .catch((err) => {
        console.error("Error fetching next event ID:", err);
        setCurrentEvent(prev => ({
          ...prev,
          eventID: ""
        }));
      });
  };

  // 開啟編輯 Modal
  const handleEdit = (item) => {
    setCurrentEvent({
      eventDBID: item.eventDBID,
      eventID: item.eventID || "",
      eventName: item.eventName || "",
      classAmount: item.classAmount || "",
      eventPrice: item.eventPrice || "0",
      classDays: item.classDays || "0",
      forMember: item.forMember || "true",
      alive: item.alive || "true",
      detail: item.detail || "",
      forTrial: item.forTrial || "false",
      forELP: item.forELP || "0"
    });
    setIsEditMode(true);
    setShowModal(true);
  };

  // 儲存資料（新增或修改）
  const handleSave = (e) => {
    e.preventDefault();
    
    // 表單欄位空值驗證
    if (!currentEvent.eventName || currentEvent.eventName.trim() === "") {
      alert("請輸入方案名稱");
      return;
    }
    if (!currentEvent.classAmount || currentEvent.classAmount.trim() === "") {
      alert("請輸入課程堂數");
      return;
    }
    if (!currentEvent.eventPrice || currentEvent.eventPrice.trim() === "") {
      alert("請輸入方案售價");
      return;
    }
    if (!currentEvent.classDays || currentEvent.classDays.trim() === "") {
      alert("請輸入期限天數");
      return;
    }
    
    const formData = new FormData();
    formData.append("eventID", currentEvent.eventID);
    formData.append("eventName", currentEvent.eventName);
    formData.append("classAmount", currentEvent.classAmount);
    formData.append("eventPrice", currentEvent.eventPrice);
    formData.append("classDays", currentEvent.classDays);
    formData.append("forMember", currentEvent.forMember);
    formData.append("alive", currentEvent.alive);
    formData.append("detail", currentEvent.detail);
    formData.append("forTrial", currentEvent.forTrial);
    formData.append("forELP", currentEvent.forELP);
    formData.append("token", token);
    formData.append("operator", operator);

    const apiPath = isEditMode ? "updateSalesEvent" : "addNewSalesEvent";
    if (isEditMode) {
      formData.append("eventDBID", currentEvent.eventDBID);
    }

    fetch(`${url}/appPost/${apiPath}`, {
      method: "POST",
      body: formData,
      mode: "cors",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.result === "success") {
          setShowModal(false);
          getData(); // 重新載入列表
        } else {
          alert("儲存失敗：" + (json.msg || "未知錯誤"));
        }
      })
      .catch((err) => {
        console.error(err);
        alert("網路或伺服器連線錯誤");
      });
  };

  return (
    <>
      <div className="container-fluid py-4" style={{ minHeight: '80vh', marginTop: '60px' }}>
        
        {/* 頁面標題與操作區 */}
        <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '12px', overflow: 'hidden' }}>
          <div className="card-body p-4 bg-white">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
              <div>
                <h4 className="font-weight-bold text-dark mb-1">課程方案管理</h4>
                <p className="text-muted small mb-0">管理目前系統中所有上架、下架的銷售專案與體驗方案</p>
              </div>
              <div className="mt-3 mt-md-0">
                <button
                  className="btn btn-info border-0 px-4 py-2 text-white font-weight-bold shadow-sm"
                  onClick={handleAddNew}
                  style={{
                    borderRadius: '8px',
                    backgroundImage: 'linear-gradient(135deg, #17a2b8, #117a8b)',
                    transition: 'all 0.3s'
                  }}
                >
                  + 新增方案
                </button>
              </div>
            </div>

            <hr className="my-3" />

            {/* 搜尋欄位 */}
            <div className="row">
              <div className="col-md-6 col-lg-4">
                <div className="input-group bg-light rounded-pill px-3 py-1 shadow-none border">
                  <input
                    type="text"
                    className="form-control border-0 bg-transparent shadow-none"
                    placeholder="搜尋方案名稱或編號..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <div className="input-group-append align-items-center">
                    <span className="text-muted small pr-1">搜尋</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 方案清單表格 */}
        <div className="card border-0 shadow-sm" style={{ borderRadius: '12px', overflow: 'hidden' }}>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover table-striped mb-0 align-middle">
                <thead className="thead-light">
                  <tr className="text-center">
                    <th scope="col" style={{ width: '60px' }}>#</th>
                    <th scope="col">編號</th>
                    <th scope="col">方案名稱</th>
                    <th scope="col">堂數</th>
                    <th scope="col">售價</th>
                    <th scope="col">期限天數</th>
                    <th scope="col">說明</th>
                    <th scope="col">正式學員</th>
                    <th scope="col">體驗學員</th>
                    <th scope="col">ELP課程</th>
                    <th scope="col">上架狀態</th>
                    <th scope="col" style={{ width: '100px' }}>操作</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {filteredList.map((item, index) => (
                    <tr 
                      key={item.eventDBID} 
                      onClick={() => handleEdit(item)}
                      style={{ cursor: 'pointer' }}
                    >
                      <th scope="row">{index + 1}</th>
                      <td className="font-weight-bold text-info">{item.eventID}</td>
                      <td>{item.eventName}</td>
                      <td>{item.classAmount} 堂</td>
                      <td className="font-weight-bold text-success">${item.eventPrice}</td>
                      <td>{item.classDays} 天</td>
                      <td 
                        style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} 
                        title={item.detail}
                      >
                        {item.detail || <span className="text-muted">-</span>}
                      </td>
                      <td>
                        {item.forMember === "true" ? (
                          <span className="badge badge-primary px-2 py-1">適用</span>
                        ) : (
                          <span className="badge badge-secondary px-2 py-1">不適用</span>
                        )}
                      </td>
                      <td>
                        {item.forTrial === "true" ? (
                          <span className="badge badge-warning text-dark px-2 py-1">適用</span>
                        ) : (
                          <span className="badge badge-secondary px-2 py-1">不適用</span>
                        )}
                      </td>
                      <td>
                        {item.forELP === "1" ? (
                          <span className="badge badge-danger px-2 py-1">是</span>
                        ) : (
                          <span className="badge badge-secondary px-2 py-1">否</span>
                        )}
                      </td>
                      <td>
                        {item.alive === "true" ? (
                          <span className="badge badge-success px-2 py-1">上架中</span>
                        ) : (
                          <span className="badge badge-danger px-2 py-1">已下架</span>
                        )}
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-info border-0"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEdit(item);
                          }}
                          style={{ borderRadius: '5px' }}
                        >
                          編輯
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {filteredList.length === 0 && (
              <div className="text-center p-5 text-muted">
                沒有找到符合條件的課程方案
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 新增/修改 Modal 彈窗 */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '600px' }}>
            <div className="modal-content shadow-lg border-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
              
              <div className="modal-header bg-info text-white border-0 py-3">
                <h5 className="modal-title font-weight-bold">
                  {isEditMode ? '編輯課程方案' : '新增課程方案'}
                </h5>
                <button type="button" className="close text-white border-0 bg-transparent" onClick={() => setShowModal(false)}>
                  <span style={{ fontSize: '1.5rem' }}>&times;</span>
                </button>
              </div>

              <div className="modal-body p-4" style={{ backgroundColor: '#f8f9fa' }}>
                <form onSubmit={handleSave}>
                  
                  {/* 方案編號 & 方案名稱 */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="font-weight-bold text-muted small mb-1">方案編號</label>
                      <input
                        type="text"
                        className="form-control border-0 shadow-sm bg-light"
                        disabled
                        value={currentEvent.eventID}
                        style={{ borderRadius: '8px' }}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="font-weight-bold text-muted small mb-1">方案名稱</label>
                      <input
                        type="text"
                        className="form-control border-0 shadow-sm"
                        required
                        placeholder="例如: 游泳常規課十堂"
                        value={currentEvent.eventName}
                        onChange={(e) => setCurrentEvent({...currentEvent, eventName: e.target.value})}
                        style={{ borderRadius: '8px' }}
                      />
                    </div>
                  </div>

                  {/* 堂數 & 售價 & 期限天數 */}
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label className="font-weight-bold text-muted small mb-1">課程堂數</label>
                      <input
                        type="text"
                        className="form-control border-0 shadow-sm"
                        required
                        placeholder="例如: 10"
                        value={currentEvent.classAmount}
                        onChange={(e) => setCurrentEvent({...currentEvent, classAmount: e.target.value})}
                        style={{ borderRadius: '8px' }}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="font-weight-bold text-muted small mb-1">方案售價</label>
                      <input
                        type="text"
                        className="form-control border-0 shadow-sm"
                        required
                        placeholder="例如: 6000"
                        value={currentEvent.eventPrice}
                        onChange={(e) => setCurrentEvent({...currentEvent, eventPrice: e.target.value})}
                        style={{ borderRadius: '8px' }}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="font-weight-bold text-muted small mb-1">期限天數</label>
                      <input
                        type="text"
                        className="form-control border-0 shadow-sm"
                        required
                        placeholder="例如: 90"
                        value={currentEvent.classDays}
                        onChange={(e) => setCurrentEvent({...currentEvent, classDays: e.target.value})}
                        style={{ borderRadius: '8px' }}
                      />
                    </div>
                  </div>

                  {/* 正式學員 & 體驗學員 & ELP課程 & 上架狀態 */}
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <label className="font-weight-bold text-muted small mb-1">適用正式學員</label>
                      <select
                        className="form-control border-0 shadow-sm"
                        value={currentEvent.forMember}
                        onChange={(e) => setCurrentEvent({...currentEvent, forMember: e.target.value})}
                        style={{ borderRadius: '8px' }}
                      >
                        <option value="true">是</option>
                        <option value="false">否</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="font-weight-bold text-muted small mb-1">適用體驗學員</label>
                      <select
                        className="form-control border-0 shadow-sm"
                        value={currentEvent.forTrial}
                        onChange={(e) => setCurrentEvent({...currentEvent, forTrial: e.target.value})}
                        style={{ borderRadius: '8px' }}
                      >
                        <option value="true">是</option>
                        <option value="false">否</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="font-weight-bold text-muted small mb-1">ELP 課程</label>
                      <select
                        className="form-control border-0 shadow-sm"
                        value={currentEvent.forELP}
                        onChange={(e) => setCurrentEvent({...currentEvent, forELP: e.target.value})}
                        style={{ borderRadius: '8px' }}
                      >
                        <option value="1">是</option>
                        <option value="0">否</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="font-weight-bold text-muted small mb-1">上架狀態</label>
                      <select
                        className="form-control border-0 shadow-sm"
                        value={currentEvent.alive}
                        onChange={(e) => setCurrentEvent({...currentEvent, alive: e.target.value})}
                        style={{ borderRadius: '8px' }}
                      >
                        <option value="true">上架</option>
                        <option value="false">下架</option>
                      </select>
                    </div>
                  </div>

                  {/* 方案說明 */}
                  <div className="mb-4">
                    <label className="font-weight-bold text-muted small mb-1">方案說明</label>
                    <textarea
                      className="form-control border-0 shadow-sm"
                      rows="3"
                      placeholder="請輸入方案的詳細說明或規則..."
                      value={currentEvent.detail}
                      onChange={(e) => setCurrentEvent({...currentEvent, detail: e.target.value})}
                      style={{ borderRadius: '8px' }}
                    />
                  </div>

                  {/* 按鈕操作 */}
                  <div className="text-right">
                    <button
                      type="button"
                      className="btn btn-secondary border-0 mr-2 shadow-sm"
                      onClick={() => setShowModal(false)}
                      style={{ borderRadius: '8px', padding: '8px 20px' }}
                    >
                      取消
                    </button>
                    <button
                      type="submit"
                      className="btn btn-info border-0 shadow-sm text-white font-weight-bold"
                      style={{
                        borderRadius: '8px',
                        padding: '8px 20px',
                        backgroundImage: 'linear-gradient(135deg, #17a2b8, #117a8b)'
                      }}
                    >
                      儲存
                    </button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GetSalesEventList;